module.exports = __webpack_public_path__ + "img/chat-details3.baaacefc.png";